"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var ConfigProvider_1 = require("../ConfigProvider");
var Dropdown_1 = tslib_1.__importDefault(require("../Dropdown"));
var input_1 = require("../Input/input");
var defs_1 = require("../Form/defs");
var icons_1 = require("../icons");
var utils_1 = require("../utils");
var hooks_1 = require("../utils/hooks");
var common_1 = require("./common");
var context_1 = require("./context");
var Selector_1 = require("./Selector");
var Overlay_1 = tslib_1.__importDefault(require("./Overlay"));
function MultiSelect(_a) {
    var valueFromProps = _a.value, _b = _a.defaultValue, defaultValue = _b === void 0 ? [] : _b, onChange = _a.onChange, placeholder = _a.placeholder, _c = _a.searchable, searchable = _c === void 0 ? false : _c, _d = _a.clearable, clearable = _d === void 0 ? false : _d, fetch = _a.fetch, _e = _a.collapsed, collapsed = _e === void 0 ? true : _e, _f = _a.groupStyle, groupStyle = _f === void 0 ? 'default' : _f, children = _a.children, _g = _a.disabled, disabled = _g === void 0 ? false : _g, size = _a.size, validateStatus = _a.validateStatus, classNameFromProps = _a.className, otherProps = tslib_1.__rest(_a, ["value", "defaultValue", "onChange", "placeholder", "searchable", "clearable", "fetch", "collapsed", "groupStyle", "children", "disabled", "size", "validateStatus", "className"]);
    var _h = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _h.value, setValue = _h.setValue;
    var _j = hooks_1.useFocused(), focused = _j.focused, focusedHandlers = _j.focusedHandlers;
    var _k = common_1.useActive(disabled), active = _k.active, selectorRef = _k.selectorRef, overlayRef = _k.overlayRef, onSelectorClick = _k.onSelectorClick;
    // 是否处于搜索状态
    var searchActive = searchable && active;
    var selectClassName = common_1.useSelectPrefix();
    var multiSelectClassName = ConfigProvider_1.usePrefix('multi-select');
    var className = classnames_1.default(input_1.useInputStyle({ size: size, validateStatus: validateStatus, disabled: disabled, focused: focused || active }), selectClassName, active && utils_1.concat(selectClassName, 'active'), searchActive && utils_1.concat(selectClassName, 'search-active'), multiSelectClassName, collapsed && utils_1.concat(multiSelectClassName, 'collapsed'), classNameFromProps);
    // 关键词输入为空时 Backspace -> 删除最后一个选中项
    var handleSearchInputPress = react_1.useCallback(function (e) {
        if (e.key === 'Backspace' && !e.currentTarget.value && value.length > 0) {
            setValue(value.slice(0, -1));
        }
    }, [value, setValue]);
    var _l = Selector_1.useSearchInput(active, {
        onKeyDown: handleSearchInputPress
    }), searchValue = _l.searchValue, setSearchValue = _l.setSearchValue, searchInput = _l.searchInput, focusSearchInput = _l.focusSearchInput;
    var clearIconView = clearable && (react_1.default.createElement(Selector_1.ClearIcon, { searchActive: searchActive, searchValue: searchValue, setSearchValue: setSearchValue, focusSearchInput: focusSearchInput }));
    var _m = common_1.useOptionItems(active, searchValue, children, fetch), items = _m.items, loading = _m.loading, getOption = _m.getOption;
    var currentOptions = value.map(getOption).filter(Boolean);
    var tags = (collapsed && currentOptions.length > 1
        ? [
            react_1.default.createElement(OptionTag, { key: "first", value: currentOptions[0].value, disabled: disabled }, currentOptions[0].content),
            react_1.default.createElement(NumTag, { key: "num" },
                "+",
                currentOptions.length - 1)
        ]
        : currentOptions.map(function (option) { return (react_1.default.createElement(OptionTag, { key: option.value, value: option.value, disabled: disabled }, option.content)); }));
    var currentOptionContent = (currentOptions.length > 0
        ? tags
        : react_1.default.createElement(Selector_1.OptionPlaceholder, null, placeholder));
    // 在当前值发生变更时（可能导致 select 高度变更）去调用 dropdown 的 forcePopupAlign
    // 确保 dropdown 相对 select 的位置是正确的
    var dropdownRef = react_1.useRef(null);
    react_1.useLayoutEffect(function () {
        if (dropdownRef.current == null)
            return;
        dropdownRef.current.forcePopupAlign();
    }, [value]);
    var handleSelect = react_1.useCallback(function (v) {
        setValue(v);
        setSearchValue('');
        focusSearchInput();
    }, [setValue, setSearchValue, focusSearchInput]);
    var formSize = defs_1.useFormSize(size);
    var selectCtxValue = react_1.useMemo(function () { return ({
        selected: value,
        onSelect: handleSelect,
        multiple: true,
        size: formSize
    }); }, [value, handleSelect, formSize]);
    var overlay = (react_1.default.createElement(Overlay_1.default, { wrapperRef: overlayRef, items: items, loading: loading, groupStyle: groupStyle }));
    return (react_1.default.createElement(context_1.SelectProvider, { value: selectCtxValue },
        react_1.default.createElement(Dropdown_1.default, { ref: dropdownRef, visible: active, overlay: overlay },
            react_1.default.createElement("div", tslib_1.__assign({}, otherProps, focusedHandlers, { className: className, ref: selectorRef, onClick: onSelectorClick }),
                react_1.default.createElement("div", { className: utils_1.concat(selectClassName, 'content') },
                    currentOptionContent,
                    searchable && searchInput),
                clearIconView,
                react_1.default.createElement(Selector_1.StatusIcon, { active: active, loading: loading, searchable: searchable })))));
}
exports.default = MultiSelect;
function OptionTag(_a) {
    var disabled = _a.disabled, value = _a.value, children = _a.children;
    var prefix = ConfigProvider_1.usePrefix('multi-select');
    var _b = context_1.useSelectCtx(), selected = _b.selected, onSelect = _b.onSelect;
    var handleClick = react_1.useCallback(function () { return onSelect(common_1.toggle(selected, value)); }, [onSelect, selected, value]);
    return (react_1.default.createElement("div", { className: utils_1.concat(prefix, 'tag'), title: utils_1.getText(children) },
        react_1.default.createElement("span", { className: utils_1.concat(prefix, 'tag', 'text') }, children),
        react_1.default.createElement(icons_1.CloseCircleFilledIcon, { className: utils_1.concat(prefix, 'tag', 'icon'), onClick: disabled ? undefined : handleClick })));
}
function NumTag(_a) {
    var children = _a.children;
    var prefix = ConfigProvider_1.usePrefix('multi-select');
    return react_1.default.createElement("div", { className: utils_1.concat(prefix, 'tag') }, children);
}
//# sourceMappingURL=MultiSelect.js.map